<div class="container-fluid">

    <div class="row">
      <div class="col-12">
        <h2 class="page-header">
          <img
            src="./assets/images/logo-bsf.png"
            style="height: 70px"
            alt="BSF LOGO"/>
        </h2>
      </div>
    </div>

    <div class="row text-center">
      <span>{{ time }}</span>
    </div>

    <div class="row">
      <pre>
    เรื่อง  ขอแก้ไขข้อมูลแปลงอ้อยปี 65/66 (ขอแก้ไขเจ้าของแปลงอ้อย)

    เรียน  ..................................................

    ข้อมูลแปลง : 05-0000196088-0002 โควตา 0000196088 นางสาวอลิษา  ละอองเอก อ้อยปลายฝน 16.57 ไร่ โซน 05 นสส.052 
    ขอแก้ไขเป็น : โควตา 0000074756 นายคำตัน  แคว้นไธสง
    เนื่องจาก : จับGPSผิดโคต้า
    


        </pre>
    </div>
    <div class="row">
        <blockquote class="blockquote">
            <p>การเบิกเกี้ยว : 10,000 บาท การเบิกปัจจัยฯ : ปุ๋ยเคมี 16 ปุ๋ยเทกอง 10 ยา 15 โดโลไมท์ 10 อุปกรณ์ 0</p>
            <footer class="blockquote-footer">From WWF's website</footer>
          </blockquote>
    </div>

    <!-- Table row -->
    <div class="row">
      <div class="col-12 table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Qty</th>
              <th>Product</th>
              <th>Serial #</th>
              <th>Description</th>
              <th>Subtotal</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>Call of Duty</td>
              <td>455-981-221</td>
              <td>El snort testosterone trophy driving gloves handsome</td>
              <td>$64.50</td>
            </tr>
            <tr>
              <td>1</td>
              <td>Need for Speed IV</td>
              <td>247-925-726</td>
              <td>Wes Anderson umami biodiesel</td>
              <td>$50.00</td>
            </tr>
            <tr>
              <td>1</td>
              <td>Monsters DVD</td>
              <td>735-845-642</td>
              <td>Terry Richardson helvetica tousled street art master</td>
              <td>$10.70</td>
            </tr>
            <tr>
              <td>1</td>
              <td>Grown Ups Blue Ray</td>
              <td>422-568-642</td>
              <td>Tousled lomo letterpress</td>
              <td>$25.99</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- /.col -->
    </div>

</div>
